import './App.css';
import Note from './components/Note';

function App() {
  return (
    <div className="App">
      <Note />
    </div>
  );
}

export default App;
